import { kpiMetricStore } from "../kpi-metric/kpi-metric-store"
import { overviewStore } from "../../overview-store"
import { langStore } from "@/stores/lang-store"
import MobileOnly from "@/components/responsive/mobile-only"
import DesktopOnly from "@/components/responsive/desktop-only"
import { carbonBundle, treeBg } from "./carbon-const"
import CarbonCard from "./carbon-card"
import Wrapper from "@/components/wrapper"

const CarbonSummaryView = () => {
  const { carbonMap } = kpiMetricStore()
  const { selectedTab } = overviewStore()
  const { lang } = langStore()

  const currentCarbon = carbonMap[selectedTab.id] || {
    elect: 0,
    gas: 0,
    water: 0,
    total: 0
  }

  const calcRatio = (val) => {
    return currentCarbon.total === 0 ? 0 : Math.round((val / currentCarbon.total) * 100)
  }

  const treeCount = Math.round(currentCarbon.total / 7.3) || 0

  const carbonItems = [
    {
      key: "elect",
      value: currentCarbon.elect,
      ratio: calcRatio(currentCarbon.elect)
    },
    {
      key: "water",
      value: currentCarbon.water,
      ratio: calcRatio(currentCarbon.water)
    },
    {
      key: "gas",
      value: currentCarbon.gas,
      ratio: calcRatio(currentCarbon.gas)
    }
  ]

  return (
    <Wrapper.shadow className="p-5 rounded-2xl flex flex-col">
      <div className="mb-5">
        <h2 className="text-lg font-bold text-gray-800">{carbonBundle.title[lang]}</h2>
        <p className="text-xs text-gray-400 mt-1">{carbonBundle.description[lang]}</p>
      </div>

      <MobileOnly className="flex justify-between mb-2">
        <div className="text-left">
          <p className="text-sm text-gray-500 font-bold">{carbonBundle.total.label[lang]}</p>
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">
            {currentCarbon.total?.toLocaleString()}
            <span className="text-base md:text-lg text-gray-500 ml-2">
              {carbonBundle.total.unit[lang]}
            </span>
          </p>
        </div>

        <div className="text-right">
          <p className="text-sm text-emerald-600 font-bold">{carbonBundle.tree.title[lang]}</p>
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">
            {treeCount.toLocaleString()}
            <span className="text-base md:text-lg text-gray-500 ml-2">
              {carbonBundle.tree.unit[lang]}
            </span>
          </p>
        </div>
      </MobileOnly>

      <section className="flex gap-4 bg-linear-to-bl rounded-lg from-emerald-50 via-white to-white">
        <article
          className={`flex flex-1 shrink-0 flex-col justify-start items-start divide-y divide-gray-100`}
        >
          {carbonItems.map((item) => (
            <CarbonCard key={item.key} item={item} lang={lang} />
          ))}
        </article>

        <MobileOnly className="flex-1 flex items-center">
          <img src={treeBg} className="w-full min-h-52 max-h-54" alt="" />
        </MobileOnly>

        <DesktopOnly className={`relative min-w-90`}>
          <div className="pt-12 text-right pr-5 relative z-1">
            <p className="text-sm text-gray-500 font-bold">{carbonBundle.total.label[lang]}</p>
            <p className="text-3xl font-bold text-gray-900">
              {currentCarbon.total?.toLocaleString()}
              <span className="text-lg text-gray-500 ml-2">{carbonBundle.total.unit[lang]}</span>
            </p>

            <div className="mt-6 py-3 text-right">
              <p className="text-sm text-emerald-600 font-bold">{carbonBundle.tree.title[lang]}</p>
              <p className=" mt-1 text-3xl font-bold">
                {treeCount.toLocaleString()}
                <span className="text-lg ml-1 text-gray-500">{carbonBundle.tree.unit[lang]}</span>
              </p>
            </div>
          </div>

          <img
            src={treeBg}
            className="w-80 h-70 absolute -left-11 top-1/2 -translate-y-1/2 z-0 opacity-85"
            alt=""
          />
        </DesktopOnly>
      </section>
    </Wrapper.shadow>
  )
}

export default CarbonSummaryView
